<template>
  <w-modal
    v-for="confirm of pendingConfirms"
    :key="confirm.id"
    hide-close
    prevent-close
    class="confirm-modal"
    :is-open="true"
  >
    <p v-html="confirm.message" />

    <template #footer>
      <w-col :gap="5">
        <w-button
          v-if="!confirm.options?.hideRejectButton"
          color="danger"
          icon="close"
          :text="confirm.options?.rejectButtonText || 'Nie'"
          @click="confirm.reject"
        />

        <w-button
          color="success"
          icon="check"
          :text="confirm.options?.acceptButtonText || 'Tak'"
          @click="confirm.accept"
        />
      </w-col>
    </template>
  </w-modal>
</template>

<script setup lang="ts">
import { computed } from 'vue'

import { confirmService } from '../../services/confirm.service'

const pendingConfirms = computed(() => confirmService.pendingConfirms.value)
</script>

<style>
.confirm-modal .w-modal {
  min-height: 100px;
}
</style>
